module.exports = __webpack_public_path__ + "static/img/item5-pick.78e293fd.png";